var React = require('react');

function IconArrowDown (props) {
    return React.createElement("svg",props,React.createElement("polyline",{"className":"cls-1","points":"0.86 0.84 12.67 12.65 24.48 0.84"}));
}

IconArrowDown.defaultProps = {"width":"25.33","height":"13.42","viewBox":"0 0 25.33 13.42"};

module.exports = IconArrowDown;

IconArrowDown.default = IconArrowDown;
